var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-1 flex flex-col"},[(_vm.MODE !== 'ext')?_c('CDNav'):_vm._e(),_vm._t("default"),(_vm.MODE !== 'ext')?_c('CDFooter'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }